import { lazy } from "react";

import ApiGroupList from "./ApiGroups/ApiGroupList";
import ApiUsersList from "./ApiUsers/ApiUsersList";
import AddBanks from "./BankList/AddBanks";
import BankList from "./BankList/BankList";
import Dashboard from "./Dashboard/Dashboard";
import OperatorSetting from "./OperatorMaster/OperatorSetting";

import TransactionHistory from "./RDS/TransactionHistory";
import RdsAgentList from "./RdsAgent/RdsAgentList";
import AllReq from "./Requisition/AllReq";
import ServiceAllocation from "./ServiceMaster/ServiceAllocation/ServiceAllocation";

const AddApiUsers = lazy(() => import("./ApiUsers/AddApiUsers"));
const AddRdsAgent = lazy(() => import("./RdsAgent/AddRdsAgent"));
const EditApiUsers = lazy(() => import("./ApiUsers/EditApiUsers"));
const EditRdsAgent = lazy(() => import("./RdsAgent/EditRdsAgent"));

const masterRoutes = [
  {
    path: "/master-admin/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/master-admin/payments/all-req",
    element: <AllReq />,
  },

  {
    path: "master-admin/transactionLog",
    element: <TransactionHistory />,
  },
  {
    path: "/master-admin/service-log",
    element: <ServiceAllocation />,
  },

  {
    path: "/master-admin/api-groups/list",
    element: <ApiGroupList />,
  },
  {
    path: "/master-admin/api-users/list",
    element: <ApiUsersList />,
  },
  {
    path: "/master-admin/rdsAgentList",
    element: <RdsAgentList />,
  },

  {
    path: "/master-admin/rds-agent/add",
    element: <AddRdsAgent />,
  },
  {
    path: "/master-admin/rds-agent/edit/:memId",
    element: <EditRdsAgent />,
  },
  {
    path: "/master-admin/api-users/add",
    element: <AddApiUsers />,
  },
  {
    path: "/master-admin/api-users/edit/:memId",
    element: <EditApiUsers />,
  },

  {
    path: "/master-admin/bank/list",
    element: <BankList />,
  },
  {
    path: "/master-admin/bank/add",
    element: <AddBanks />,
  },

  {
    path: "/master-admin/operatorMaster/operatorSetting",
    element: <OperatorSetting />,
  },
];

export default masterRoutes;
